/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';
import { VscDebugDisconnect } from 'react-icons/vsc';

import CopyToClipboard from 'partial/components/CopyToClipboard';
import { useGetApiKeyList, useApiKeyActiveInactive } from '../hooks';
import FormToggle from 'partial/form/FormToggle';
import { openTestApiModal } from '../modals/TestApiModal';
import { useShowRegenerateApiKeyModal } from '../modals/RegenerateApiKeyModal';

function ApiKeysContainer() {
  const [isLoading, data] = useGetApiKeyList();
  const renderTry = React.useMemo(() => {
    const openTest = () => {
      openTestApiModal();
    };
    return (
      <div>
        <Button secondary onClick={openTest}>
          Test API
        </Button>
      </div>
    );
  }, []);
  return (
    <Card label="API Tokens" renderAction={renderTry}>
      <div className="flex-grow flex flex-col divide-y">
        {data.length < 1 ? (
          <div className="text-center text-gray-500 py-6 px-10">
            {isLoading ? 'Loading...' : 'There are no items.'}
          </div>
        ) : (
          data?.map((item) => (
            <div key={item?.api_key_id}>
              <ApiKeyItem item={item} />
            </div>
          ))
        )}
      </div>
    </Card>
  );
}

ApiKeysContainer.propTypes = {};

export default ApiKeysContainer;

function ApiKeyItem({ item }) {
  const [isLoading, activeInactive] = useApiKeyActiveInactive();
  const [openRegenerateModal] = useShowRegenerateApiKeyModal();
  const [isActive, setIsActive] = useState(item?.status === 'ACTIVE');

  const maskText = (str, mask = '*', n = 4) => {
    if (!isEmpty(str)) {
      return `${str.slice(0, -n).replace(/./g, mask)}${str.slice(-n)}`;
    }
    return '';
  };

  const handleActiveInactive = (isActive) => {
    if (isActive) {
      activeInactive(item?.merchant_id, item?.api_key_id, 'Active');
      return;
    }
    activeInactive(item?.merchant_id, item?.api_key_id, 'Inactive');
  };

  const handleRegenerate = () => openRegenerateModal(item);

  useEffect(() => setIsActive(item?.status === 'ACTIVE'), [item]);

  return (
    <div className="flex justify-between py-6 px-10">
      <div className="flex space-x-6 items-center">
        <div>
          <VscDebugDisconnect className="h-16 w-16 border-2 rounded-xl p-3 text-primary-800" />
        </div>
        <div className="flex flex-col">
          <h1 className="text-lg mb-2">{item?.api_type}</h1>
          <div className="flex">
            <span className="w-40 font-light">Token Key:</span>
            <span className="font-medium">
              <CopyToClipboard
                value={maskText(item?.token)}
                copyValue={item?.token}
              />
            </span>
          </div>
          <div className="flex">
            <span className="w-40 font-light">Queue Code:</span>
            <span className="font-light">{item?.queue_code}</span>
          </div>
          <div className="flex">
            <span className="w-40 font-light">Callback URL:</span>
            <span className="font-light">{item?.callback_url}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center space-y-2">
        <div className="flex items-center space-x-2">
          <div className="flex space-x-2">
            <div className="w-16">
              <label
                htmlFor="apiKey"
                className={`capitalize ${
                  isActive ? 'text-secondary-600' : 'text-red-500'
                }`}
              >
                {isActive ? 'Active' : 'Inactive'}
              </label>
            </div>
            <FormToggle
              name={`is_active`}
              onChange={(cb) => {
                const isActive = cb().is_active;
                handleActiveInactive(isActive);
                setIsActive(isActive);
              }}
              checked={isActive}
              label=""
              secondary
              disabled={isLoading}
            />
          </div>
        </div>
        <Button outlinePrimary size="sm" onClick={handleRegenerate}>
          Regenerate Key
        </Button>
      </div>
    </div>
  );
}

ApiKeyItem.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
};
